import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  feeSetup: {
    data: {
      fees: []
    }
  },
};

export const feeSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FEE_SETUP:
      return {
        ...state,
        feeSetup: action.payload,
      };
    case actionTypes.SAVE_FEE_SETUP:
      return {
        ...state,
        feeSetup: action.payload,
      };
    default:
      return state;
  }
};
